<template>
  <span>
    <span v-if="showProductIcon">
      <i
        class="mdi mdi-barcode-scan"
        v-if="isInventoryProduct"
        style="font-size:18px;margin-right:5px;color: grey;" />
      <i
        v-else
        class="mdi mdi-cards-variant"
        style="font-size:18px;margin-right:5px;color: grey;"></i>
    </span>
    <span style="word-break:break-word;">
      <el-link
        @click="openProductDrawer()"
        v-if="isInventoryProduct && showDetailProduct">
          {{productName}}
      </el-link>
      <span v-else>{{productName}}</span>
      <span v-if="isProviderExists">
        <br>
        <el-link @click="openProvider()">
          {{providerName}}
        </el-link>
      </span>
    </span>
    <span v-if="getFormatedBatchNumber">
      <br>
      {{getFormatedBatchNumber}}
    </span>
    <span v-if="isInventoryProduct">
      <br>
      <UnitFormatVolumeLabel
        :unit="unit"
        :uvc="uvc"
        :format="format"
        :volume="volume" />
    </span>
    <span v-if="descriptionExists" >
      <br/>{{description}}
    </span> 
    <span v-if="tagsExist">
      <br>
      <el-tag
        type="info"
        size="small"
        effect="dark"
        class="mr-5">
        <span v-if="reservation">
          Réservation
        </span>
        <span v-if="inventory && isMultipleInventorySystem">
          {{inventory.name}}
        </span>
      </el-tag>
    </span>

    <ProductDetailDrawer
      :puid="puid"
      direction="ltr"
      :visible="productDetailDrawerVisible"
      @close="closeProductDetailDrawer" />
  </span>
</template>
<script>

import CustomerUtil from '@/utils/customer-util';
import UnitFormatVolumeLabel from '@/components/product/unitFormatVolumeLabel';
import ProductUtil from '@/utils/product-util'
import ProductDetailDrawer from '@/views/pages/inventory/components/product-detail-drawer'
import { mapActions, mapState, mapGetters } from 'vuex';

export default {
  name: 'Sales-product-definition',
  props: {
		product : {
      type: Object,
      default : null,
    },
    inventory: {
      type: Object,
      default : null,
    },
    reservation: {
      type: Object,
      default : null,
    },
    vintage : {
      type: String,
      default : null,
    },
    item: {
      type: Object,
      default: null,
    },
    showDetailProduct : {
      type: Boolean,
      default: true
    },
    showProductIcon: {
      type: Boolean,
      default: true
    },
    description: {
      type: String,
      default: null
    }
	},
  data() {
    return {
      productDetailDrawerVisible: false,

    };
  },components: {
    UnitFormatVolumeLabel,
    ProductDetailDrawer
  },
	methods: {
    openProductDrawer(){
      this.productDetailDrawerVisible = true;
    },
    closeProductDetailDrawer () {
      this.productDetailDrawerVisible = false;
    },
    openProvider(){
      var index='/customers/'+this.providerId;
      this.$router.push(index);
    },
	},
	computed: {
    descriptionExists () {
      return this.description != null;
    },
    getFormatedBatchNumber(){
      if (_.get(this.inventory, 'code') === 'IP' && this.item != null) {
        return ProductUtil.formatBatchNumber(this.item.reference, this.inventory.code === 'IP');
      }
      return null;

    },
    providerName () {
      if (this.provider == null) return null;
      return CustomerUtil.customerName(this.provider.name, this.provider.usualName);
    },
    tagsExist () {
      return this.reservation != null || ( this.inventory != null  && this.isMultipleInventorySystem)
    },
    inventoryId () {
      return _.get(this.inventory, 'id');
    },
    puid () {
      return _.get(this.product, 'puid');
    },
    provider () {
      return _.get(this.product, 'provider');
    },
    providerId () {
      return _.get(this.product, 'provider.id');
    },
    isProviderExists () {
      return _.get(this.product, 'provider') != null;
    },
    unit () {
      return _.get(this.product, 'unit');
    },
    uvc () {
      return _.get(this.product, 'uvc');
    },
    format () {
      return _.get(this.product, 'format');
    },
    volume () {
      return _.get(this.product, 'volume');
    },
    isInventoryProduct () {
      return this.productType === 1;
    },
    isServiceProduct () {
      return this.productType === 0;
    },
    productType () {
      return _.get(this.product, 'type');
    },
    productName () {
      if (this.vintage != null) {
        return `${_.get(this.product, 'name')} ${this.vintage}`;
      }
      if (_.get(this.product, 'extendedName') != null) {
        return _.get(this.product, 'extendedName')
      }
      return _.get(this.product, 'name');
    },
     ...mapGetters('inventory', ['isMultipleInventorySystem'])
	},
	watch : {

	},
	mounted(){

	},
	created(){

	}
}
</script>

<style lang="scss" scoped>

</style>
